import styled from 'styled-components';

export const ImportReportDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
